"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgSchedule(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M20 8v6l-1.579-.961-.54.598c-.04.043-.07.074-.083.086A8.151 8.151 0 0112.136 16c-3.746 0-6.901-2.49-7.847-5.878l1.836-1.087C6.625 11.852 9.129 14 12.136 14c1.493 0 2.877-.508 3.918-1.414l.238-.214c.16-.146.313-.29.405-.377L15 10.968zm-8.136-8c3.81 0 7.008 2.575 7.893 6.05l-1.864 1.02C17.437 4.2 14.907 2 11.864 2c-1.493 0-2.877.508-3.918 1.414l-.238.214c-.16.146-.313.29-.405.377L9 5.032 4 8V2l1.579.961.54-.598c.04-.043.07-.074.083-.086A8.151 8.151 0 0111.864 0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Schedule')(SvgSchedule);
//# sourceMappingURL=Schedule.js.map